import { Route, Routes } from "react-router-dom";
import SubscriptionsPage from "../../pages/features/subscriptions/SubscriptionsPage";



export default function SubscriptionNav() {
  return (
    <Routes>

      <Route path="/" element={<SubscriptionsPage />} />
    

    </Routes>
  );
}
